const AuditTrail = () => <h1>Audit Trail</h1>

export default AuditTrail
